import { defineMessages } from 'react-intl'

export default defineMessages({
  all: {
    id: 'All',
    defaultMessage: 'All'
  },
  details: {
    id: 'Details',
    defaultMessage: 'Details'
  },
  connectorLogs: {
    id: 'ConnectorLogPage.ConnectorLogs',
    defaultMessage: 'Connector Logs'
  },
  correlationId: {
    id: 'CorrelationId',
    defaultMessage: 'Correlation Id'
  },
  noLogs: {
    id: 'ConnectorLogPage.NoLogs',
    defaultMessage: 'There are no connector log records found for the selected filters.'
  },
  fetchingLogs: {
    id: 'ConnectorLogPage.FetchingLogs',
    defaultMessage: 'Fetching Connector Logs...'
  },
  end: {
    id: 'End',
    defaultMessage: 'End'
  },
  start: {
    id: 'Start',
    defaultMessage: 'Start'
  },
  refreshButton: {
    id: 'Refresh',
    defaultMessage: 'Refresh'
  },
  logs: {
    id: 'Logs',
    defaultMessage: '{connectorName} Logs'
  }
})
